import { uniqueId as lodashUniqueId } from 'lodash';
export var uniqueId = function uniqueId() {
  return lodashUniqueId(Math.random().toString().slice(2));
};
export default uniqueId;